var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { GridHeaderContainer } from "./GridHeaderContainer";
import { styles } from "./styles";
export function createGridHeaderRenderer() {
    return function gridHeaderRenderer(_a) {
        var columns = _a.columns, containerRef = _a.containerRef, rowWidth = _a.rowWidth, className = _a.className, style = _a.style;
        var headerCells = columns.map(function (config, idx) {
            var _a;
            return (React.createElement("div", { className: styles.cell, key: config.id, style: {
                    width: config.width,
                    minWidth: config.width,
                    maxWidth: config.width,
                    flexBasis: config.width
                } }, (_a = config.header) === null || _a === void 0 ? void 0 : _a.call(config, { cellIndex: idx, column: config, className: '' })));
        });
        return (React.createElement(GridHeaderContainer, { key: 'header-container', containerRef: containerRef, style: __assign({ width: rowWidth }, style), className: className }, headerCells));
    };
}
//# sourceMappingURL=createGridHeaderRenderer.js.map